import { useCallback } from 'react';

type HapticIntensity = 'light' | 'medium' | 'heavy';

export const useHapticFeedback = () => {
  const vibrate = useCallback((pattern: number | number[] = 10) => {
    if ('vibrate' in navigator) {
      navigator.vibrate(pattern);
    }
  }, []);

  const light = useCallback(() => {
    vibrate(10);
  }, [vibrate]);

  const medium = useCallback(() => {
    vibrate(25);
  }, [vibrate]);

  const heavy = useCallback(() => {
    vibrate(50);
  }, [vibrate]);

  const success = useCallback(() => {
    vibrate([10, 50, 30]);
  }, [vibrate]);

  const error = useCallback(() => {
    vibrate([50, 30, 50, 30, 50]);
  }, [vibrate]);

  const discovery = useCallback(() => {
    vibrate([10, 30, 10, 30, 10, 100]);
  }, [vibrate]);

  const pulse = useCallback(() => {
    vibrate([5, 20, 5, 20, 5]);
  }, [vibrate]);

  const tap = useCallback((intensity: HapticIntensity = 'light') => {
    const patterns: Record<HapticIntensity, number> = {
      light: 10,
      medium: 25,
      heavy: 50,
    };
    vibrate(patterns[intensity]);
  }, [vibrate]);

  const isSupported = 'vibrate' in navigator;

  return {
    vibrate,
    light,
    medium,
    heavy,
    success,
    error,
    discovery,
    pulse,
    tap,
    isSupported,
  };
};

export default useHapticFeedback;
